import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { SZZA001AService } from './apis/sZZA001A.service';
import { SZZA002AService } from './apis/sZZA002A.service';
import { SZZA004AService } from './apis/sZZA004A.service';
import { SZZA005AService } from './apis/sZZA005A.service';
import { SZZA006AService } from './apis/sZZA006A.service';
import { SZZA007AService } from './apis/sZZA007A.service';
import { SZZA008AService } from './apis/sZZA008A.service';
import { SZZA009AService } from './apis/sZZA009A.service';
import { SZZA010AService } from './apis/sZZA010A.service';
import { SZZA011AService } from './apis/sZZA011A.service';
import { SZZA012AService } from './apis/sZZA012A.service';
import { SZZA016AService } from './apis/sZZA016A.service';
import { SZZA017AService } from './apis/sZZA017A.service';
import { SZZA018AService } from './apis/sZZA018A.service';
import { SZZA019AService } from './apis/sZZA019A.service';
import { SZZA020AService } from './apis/sZZA020A.service';
import { SZZA021AService } from './apis/sZZA021A.service';
import { SZZA022AService } from './apis/sZZA022A.service';
import { SZZA023AService } from './apis/sZZA023A.service';
import { SZZA024AService } from './apis/sZZA024A.service';
import { SZZA025AService } from './apis/sZZA025A.service';
import { SZZA026AService } from './apis/sZZA026A.service';
import { SZZA027AService } from './apis/sZZA027A.service';
import { SZZA028AService } from './apis/sZZA028A.service';
import { SZZA029AService } from './apis/sZZA029A.service';
import { SZZA030AService } from './apis/sZZA030A.service';
import { SZZA031AService } from './apis/sZZA031A.service';
import { SZZA911AService } from './apis/sZZA911A.service';
import { SZZA912AService } from './apis/sZZA912A.service';
import { SZZA913AService } from './apis/sZZA913A.service';
import { SGKZ010AService } from './apis/sGKZ010A.service';
import { SGKZ011AService } from './apis/sGKZ011A.service';
import { SGKZ020AService } from './apis/sGKZ020A.service';
import { SGKZ021AService } from './apis/sGKZ021A.service';
import { SGKZ022AService } from './apis/sGKZ022A.service';
import { SGKZ030AService } from './apis/sGKZ030A.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class SysApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<SysApiModule> {
        return {
            ngModule: SysApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: SysApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('SysApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
